<script lang='ts'>
  import * as _ from 'lodash'
  import Sortable from 'sortablejs';
  import Icon from '../../../../../../shared/javascripts/svelte/Components/Icon.svelte'
  import { tick } from 'svelte';
  import type { StorefrontProductCard, StorefrontCollection } from 'app/javascript/shared/javascripts/types/Storefront';

  export let productCards : StorefrontProductCard[];
  export let saveRemove : (card : StorefrontProductCard) => any;
  export let saveSort: any;
  export let collection : StorefrontCollection

  let sortObj: any;
  let sortOrder:object[];

  function doSort() {
    sortOrder = [];
    let nodes = document.getElementById('cards-to-sort-' + collection.id).childNodes;
    if (!((nodes || []).length > 0)) { return }

    let position : number = 0;
    nodes.forEach(function(l) {
      if (!(l instanceof HTMLElement)) {
        // fixes type issue
        return;
      }
      if (_.get(l, 'dataset.key') && l.dataset.key != 'undefined') {
        sortOrder.push({id: parseInt(l.dataset.key), position: position})
        position += 1;
      }
    });
    saveSort(sortOrder);
  }

  async function initSort() {
    await tick()
    setTimeout(function() {
      var el = document.getElementById('cards-to-sort-' + collection.id);
      if (el) {
        sortObj = Sortable.create(el,
          {
            onSort: function() {
              doSort()
            },
            handle: '.grab-handle'
          }
        );
        return sortObj;
      }
    }, 1000);
  }

  $: initSort();
  $: {
    collection = collection;
  }
</script>
<ul class="fizz-drag-and-drop fizz-stack-16 fizz-flow-4" id='cards-to-sort-{collection.id}'>
  {#each productCards as productCard (productCard.id)}
    <li class="fizz-space-between"
      id='product-card-{productCard.id}' data-key={productCard.id} data-id={productCard.id}>
      <Icon
        width="16"
        height="16"
        type="GrabHandle" extraClassNames='cursor-grab grab-handle'
      ></Icon>
      <span>{productCard.product_line.name}</span>
      <Icon
        width="16"
        height="16"
        type="X" extraClassNames='cursor-pointer'
        onPress={() => saveRemove(productCard)}
      ></Icon>
    </li>
  {/each}
</ul>